import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OriginalProductConversionCard } from '../../../models/product-conversion.model';
import { PlatformEnum } from '@panamax/app-state';
import { ProductDetailViewModel } from '@product-detail/models/product-detail-view-model';

@Component({
  selector: 'app-original-product-for-conversion',
  templateUrl: './original-product-for-conversion.component.html',
  styleUrls: ['./original-product-for-conversion.component.scss'],
})
export class OriginalProductForConversionComponent {
  @Input() product: OriginalProductConversionCard;
  @Input() platform: PlatformEnum;
  @Input() pricingDisabled: boolean;
  @Input() showKeepProductButton: boolean;

  @Output() keepProductEvent: EventEmitter<void> = new EventEmitter();
  @Output() productImageClickEmitter: EventEmitter<ProductDetailViewModel> =
    new EventEmitter();

  readonly PlatformEnum = PlatformEnum;
  constructor() {}

  handleKeepProductClick() {
    this.keepProductEvent.emit();
  }

  handleProductImageClick() {
    this.productImageClickEmitter.emit(this.product);
  }
}
